module.exports = __webpack_public_path__ + "static/media/5.86a6e18d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/5.png
// module id = 64
// module chunks = 0